import { render, staticRenderFns } from "./BackupItem.vue?vue&type=template&id=530c6ab6"
import script from "./BackupItem.vue?vue&type=script&lang=js"
export * from "./BackupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports